module.exports = __webpack_public_path__ + "static/img/img_5.449d7d65.jpg";